// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1486":"e5c273a11ec97430","5343":"265566cccda366b2","8930":"e3dd09b05ac4e176"}[chunkId] + ".css";
};